'use client';
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {connect} from '@stubhub/react-store-provider';
import UrgencyCore from '@stubhub/react-urgency-core';

import controller from './controller';

const Urgency = ({showUrgencyRewording = false, className, eventDateLocal, onSaleDate, totalTickets}) => {
  return (
    <UrgencyCore
      showUrgencyRewording={showUrgencyRewording}
      className={className}
      eventDateLocal={eventDateLocal}
      onSaleDate={onSaleDate}
      totalTickets={totalTickets}
      messageFormatter={FormattedMessage}
    />
  );
};

Urgency.propTypes = {
  /** Custom classname to apply */
  className: PropTypes.string,

  /** Event local date in ISO format */
  eventDateLocal: PropTypes.string,

  /** On sale date for the event in ISO format*/
  onSaleDate: PropTypes.string,

  /** Total tickets left */
  totalTickets: PropTypes.number,

  /** Controls tickets left text variant */
  showUrgencyRewording: PropTypes.bool,
};

export default connect(controller)(Urgency);
